export const NAMESPACE = 'rdc-preview-session';

export const MOBILE_DEVICE_STATES = Object.freeze({
  OFFLINE: 'OFFLINE',
  LAUNCH: 'LAUNCH',
  VIDEO: 'VIDEO',
  BOOTED: 'BOOTED',
  INPUT: 'INPUT',
  ONLINE: 'ONLINE',
  UI: 'UI',
});

export const MOBILE_SESSION_STATES = Object.freeze({
  SESSION_CREATION_FAILED: 'SESSION_CREATION_FAILED',
  DEVICE_CONNECTION_FAILED: 'DEVICE_CONNECTION_FAILED',
  DEVICE_DISCONNECTED: 'DEVICE_DISCONNECTED',
  APP_INSTALLATION_FAILED: 'APP_INSTALLATION_FAILED',
  INITIAL: 'INITIAL',
  REQUESTING: 'REQUESTING',
  ALLOCATING: 'ALLOCATING',
  PREPARING: 'PREPARING',
  INSTALLING: 'INSTALLING',
  READY: 'READY',
});
